"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _generateLicense = require("./generateLicense");
Object.keys(_generateLicense).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _generateLicense[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _generateLicense[key];
    }
  });
});